module.exports = __webpack_public_path__ + "static/img/island.685ab59.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/graphics/island.svg
// module id = 1spv
// module chunks = 1